import React, { useEffect, useState } from "react";
import "./index.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useIdleTimer } from "../../context/idleTimoutContext";
import Button from "../../components/Buttons";
import { usePages } from "../../context/pagesContext";
import Slideshow from "../../components/Slideshow";

type pageParams = {
  slug: string;
};

function PageContent() {
  const navigate = useNavigate();
  const idleTimer = useIdleTimer();
  const { pages, findPage } = usePages()!;
  const { slug } = useParams<pageParams>();
  const [page, setPage] = useState<any>(null);
  const [pageContent, setPageContent] = useState<any>(null);
  const [activeSubPage, setActiveSubPage] = useState<any>(null);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
  const colors = [
    "#f32360",
    "#8866d4",
    "#5d8af1",
    "#1faed9",
    "#62d2d5",
    "#2ccb96",
    "#ffd348",
  ];

  useEffect(() => {
    setPageContent([]);
    setActiveSubPage(null);
    getPage();
  }, [pages, slug]);

  useEffect(() => {
    if (activeSubPage) {
      setPageContent(activeSubPage?.content);
    } else {
      setPageContent(page?.content);
    }
  }, [page, activeSubPage]);

  const getPage = () => {
    if (slug) {
      const _page = findPage(slug);
      setPageContent(_page?.content);
      setPage(_page);
    }
  };

  return (
    <div className={`pageContent`}>
      {page && (
        <div
          className={`content ${page?.subPages?.length ? "subNavActive" : ""}`}
        >
          <h1 className="pageTitle">{page.title}</h1>

          <div className="pageData">
            {pageContent?.length ? (
              pageContent.map((contentItem: any, index: number) => {
                return (
                  <React.Fragment key={index}>
                    {contentItem.type === "text" && (
                      <div
                        className="htmlContent"
                        dangerouslySetInnerHTML={{
                          __html: contentItem.content,
                        }}
                      ></div>
                    )}
                    {contentItem.type === "slideshow" && (
                      <Slideshow media={contentItem.media} />
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <p>No content</p>
            )}
            <div className="more">
              <img src="/images/scroll.png" />
            </div>
          </div>
        </div>
      )}

      {pages && (
        <div className="mainNav">
          {pages.map((item: any, index: number) => {
            return (
              <nav
                className={`${item.slug === slug ? "active" : ""}`}
                key={index}
                onClick={() => navigate(`/pages/${item.slug}`)}
              >
                {item.title}
              </nav>
            );
          })}
        </div>
      )}

      {pages && page?.subPages?.length > 0 && (
        <div className="subPageNav">
          <nav
            onClick={() => setActiveSubPage(null)}
            className={`${!activeSubPage ? "active" : ""}`}
            style={{
              backgroundColor: activeSubPage ? colors[page.index % 7] : "",
              borderColor: colors[page.index % 7],
            }}
          >
            {page.title} Intro.
          </nav>
          {page.subPages.map((item: any, index: number) => {
            return (
              <nav
                className={`${item === activeSubPage ? "active" : ""}`}
                style={{
                  backgroundColor:
                    item != activeSubPage ? colors[page.index % 7] : "",
                  borderColor: colors[page.index % 7],
                }}
                key={index}
                onClick={() => setActiveSubPage(item)}
              >
                {item.title}
              </nav>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default PageContent;
